// extracted by mini-css-extract-plugin
export default {"label":"textItem_label__pf-QW","text":"textItem_text__9iiCd","inline":"textItem_inline__WvOp9","capitalize":"textItem_capitalize__1Var5"};